import { createInstance } from '@amplitude/analytics-browser'
import { BrowserOptions } from '@amplitude/analytics-core'
import { BrowserClient } from '@amplitude/analytics-types'
import { NoopService } from '../noopService'

const apiKey = import.meta.env.VITE_AMPLITUDE_API_KEY

let client: BrowserClient

function getClient(options?: Partial<BrowserOptions>): BrowserClient {
    if (client) return client

    if (!apiKey) {
        client = NoopService.fromService('Amplitude')
        return client
    }

    const instance = createInstance()
    instance.init(apiKey, {
        serverZone: 'EU',
        identityStorage: 'none',
        defaultTracking: {
            attribution: true,
            fileDownloads: false,
            formInteractions: false,
            pageViews: false,
            sessions: true,
        },
        ...options,
    })

    client = instance
    return client
}

export default { getClient }
